(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-review-config]').textContent);
    const list = root.querySelector('.rlist');
    const template = list.querySelector('.rrow')?.cloneNode(true);
    if (!template) return;
    const more = root.querySelector('[data-review-more]');
    const button = more?.querySelector('button');
    const status = root.querySelector('[data-review-status]');
    let reviews = config.seeds;
    let limit = 3;
    let rating = null;
    let loaded = false;
    let loading;
    const dateFormat = new Intl.DateTimeFormat('en', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
    const sort = rows => [...new Map(rows.map(row => [row.uuid, row])).values()]
      .sort((a, b) => Number(b.rating) - Number(a.rating) || Date.parse(b.created_at) - Date.parse(a.created_at) || a.uuid.localeCompare(b.uuid));
    const decode = value => String(value || '').replace(/&(?:#\d+|#x[\da-f]+|[a-z][\da-z]+);/gi, entity => new DOMParser().parseFromString(entity, 'text/html').body.textContent);
    const safeUrl = value => {
      try {
        const url = new URL(value, location.origin);
        return /^https?:$/.test(url.protocol) ? url.href : '';
      } catch { return ''; }
    };
    const stars = (element, value) => {
      element.replaceChildren();
      for (let i = 1; i <= 5; i++) {
        const star = document.createElement('span');
        star.textContent = '★';
        if (i > Math.round(value)) star.className = 'off';
        element.append(star);
      }
    };
    function card(review) {
      const row = template.cloneNode(true);
      row.classList.remove('rhide');
      row.hidden = false;
      row.dataset.reviewId = review.uuid;
      row.dataset.rating = review.rating;
      row.querySelector('.rname').textContent = decode(review.reviewer_name);
      row.querySelector('.rprod b').textContent = decode(review.product_title);
      row.querySelector('.rfin').textContent = dateFormat.format(new Date(review.created_at));
      row.querySelector('h3').textContent = decode(review.title);
      const body = document.createElement('p');
      body.textContent = decode(review.body) || new DOMParser().parseFromString(review.body_html || '', 'text/html').body.textContent;
      row.querySelector('.rbody').replaceChildren(body);
      stars(row.querySelector('.rstars'), review.rating);
      const thumb = row.querySelector('.rthumb');
      thumb.replaceChildren();
      const imageUrl = safeUrl(review.product_variant_image_url || '');
      if (review.product_variant_image_url && imageUrl) {
        const img = document.createElement('img');
        Object.assign(img, { src: imageUrl, alt: '', loading: 'lazy', width: 48, height: 48 });
        thumb.append(img);
      }
      const media = row.querySelector('.rmedia');
      media.replaceChildren(...(review.pictures_urls || []).flatMap(picture => {
        const url = safeUrl(picture.original || picture);
        if (!url) return [];
        const link = document.createElement('a');
        Object.assign(link, { href: url, target: '_blank', rel: 'noopener' });
        const img = document.createElement('img');
        Object.assign(img, {
          src: safeUrl(picture.small || picture.compact || url),
          alt: `${decode(review.reviewer_name)} — ${decode(review.product_title)}`,
          loading: 'lazy', width: 160, height: 160
        });
        link.append(img);
        return [link];
      }));
      row.querySelector('.rreply')?.remove();
      if (review.reply_content) {
        const reply = document.createElement('div');
        reply.className = 'rreply';
        const name = document.createElement('b');
        name.textContent = decode(review.shop_reply_name || 'Skopos Eyewear');
        const text = document.createElement('p');
        text.textContent = new DOMParser().parseFromString(review.reply_content, 'text/html').body.textContent;
        reply.append(name, text);
        row.querySelector('.rhelp').before(reply);
      }
      const votes = row.querySelectorAll('.rhelp i');
      votes[0].textContent = review.thumb_up || 0;
      votes[1].textContent = review.thumb_down || 0;
      return row;
    }
    function render() {
      const filtered = reviews.filter(review => rating === null || Number(review.rating) === rating);
      list.replaceChildren(...filtered.slice(0, limit).map(card));
      if (more) more.hidden = loaded && filtered.length <= limit;
      root.querySelectorAll('.hrow').forEach(row => {
        const active = Number(row.dataset.rating) === rating;
        row.classList.toggle('active', active);
        row.setAttribute('aria-pressed', String(active));
      });
    }
    function updateSummary() {
      const count = reviews.length;
      if (!count) return;
      const average = reviews.reduce((sum, row) => sum + Number(row.rating), 0) / count;
      root.querySelector('.rscore').textContent = average.toFixed(2);
      root.querySelector('.rcount').textContent = config.labels.summary.replace('__COUNT__', count);
      stars(root.querySelector('.rsummary > .rstars'), average);
      document.querySelectorAll('[data-shared-review-badge]').forEach(badge => {
        badge.querySelector('[data-review-count]').textContent = config.labels.count.replace('__COUNT__', count);
        /* 2026-09-27: badge keeps partial stars that match the average (4.7 = 4 full + 70 % of the fifth) */
        const bs = badge.querySelector('b');
        if (bs && bs.classList.contains('starrow-stars')) {
          const fill = bs.children[1];
          if (fill) fill.style.width = `${Math.min(100, Math.max(0, average / 5 * 100))}%`;
          bs.setAttribute('aria-label', `${average.toFixed(2)} out of 5 stars`);
        } else if (bs) stars(bs, average);
      });
      root.querySelectorAll('.hrow').forEach(row => {
        const frequency = reviews.filter(review => Number(review.rating) === Number(row.dataset.rating)).length;
        row.querySelector('.hc').textContent = frequency;
        row.querySelector('.hfill').style.width = `${frequency / count * 100}%`;
        row.disabled = frequency === 0;
      });

    }
    async function fetchProduct(source) {
      const rows = [];
      let totalPages = 1;
      for (let page = 1; page <= totalPages; page++) {
        const url = new URL('https://judge.me/api/v1/widgets/product_review');
        url.search = new URLSearchParams({ shop_domain: config.shop, api_token: config.publicToken, handle: source.handle, json_request: 'true', per_page: '30', page: String(page) });
        const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Reviews unavailable');
        const data = await response.json();
        if (!Array.isArray(data.reviews) || Number(data.current_page) !== page) throw new Error('Invalid review page');
        totalPages = Number(data.total_pages);
        if (!Number.isFinite(totalPages) || totalPages > 100) throw new Error('Invalid review pagination');
        rows.push(...data.reviews);
      }
      return rows;
    }
    function load() {
      if (loaded) return Promise.resolve(true);
      if (loading) return loading;
      if (button) { button.disabled = true; button.textContent = config.labels.loading; }
      status.hidden = true;
      loading = Promise.all(config.sources.map(fetchProduct)).then(results => {
        const allowed = new Set(config.sources.map(source => source.handle));
        const completeReviews = sort(results.flat().filter(review => {
          const path = new URL(review.product_url, location.origin).pathname.split('/').filter(Boolean);
          return allowed.has(path[path.length - 1]);
        }));
        if (!completeReviews.length && config.seeds.length) throw new Error('Empty review response');
        reviews = completeReviews;
        loaded = true;
        updateSummary();
        render();
        return true;
      }).catch(() => {
        status.textContent = config.labels.error;
        status.hidden = false;
        return false;
      }).finally(() => {
        loading = null;
        if (button) { button.disabled = false; button.textContent = config.labels.more; }
      });
      return loading;
    }
    button?.addEventListener('click', async () => {
      limit += 12;
      render();
      await load();
    });
    root.querySelectorAll('.hrow').forEach(row => row.addEventListener('click', async () => {
      const requested = Number(row.dataset.rating);
      rating = requested === rating ? null : requested;
      limit = 15;
      render();
      await load();
    }));
    reviews = sort(reviews);
    render();
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, { rootMargin: '300px' });
    observer.observe(root);
  }
  document.querySelectorAll('[data-shared-reviews]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-shared-reviews]').forEach(initialize));
})();
